import { axios } from "..";
import { IAreaOfPractice } from "../interfaces/models/IAreaOfPractice";

export const getAllAops = async () => {
  try {
    const response = await axios.Get(`/AreaOfPractice`);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const createAop = async (aop: IAreaOfPractice) => {
  try {
    const response = await axios.Post(`/AreaOfPractice`, aop);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateAop = async (aop: IAreaOfPractice) => {
  try {
    const response = await axios.Put(`/AreaOfPractice`, aop);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteAop = async (id: string) => {
  try {
    const response = await axios.Delete(`/AreaOfPractice`, `${id}`);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAOPsByOffice = async (officeId: string) => {
  try {
    const params = new URLSearchParams();
    params.append("filter", JSON.stringify({ offices: { value: [officeId] } }));
    const response = await axios.Get(`/AreaOfPractice?${params.toString()}`);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAOPsByFirm = async (firmId: string) => {
  try {
    const response = await axios.Get(
      `/areaOfPractice?action=getByFirmId&firmId=${firmId}`,
    );
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

export const getAOPsByIds = async (
  ids: string[],
): Promise<IAreaOfPractice[]> => {
  const unique = [
    ...new Set(
      (ids ?? []).map((id) => String(id ?? "").trim()).filter(Boolean),
    ),
  ];
  if (unique.length === 0) {
    return [];
  }

  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({ id: { value: unique, comparisonType: "IN" } }),
    );
    params.append(
      "pagination",
      JSON.stringify({ pageIndex: 0, pageSize: Math.max(unique.length, 1) }),
    );
    const response = await axios.Get(`/AreaOfPractice?${params.toString()}`);
    return Array.isArray(response?.data) ? response.data : [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
